// KB-971: la app de docentes solo muestra cursos con active = true. En la ficha del
// docente los inactivos se muestran aparte, pero sus ids NO se sacan del payload:
// el update de content-manager borra todo courseteacher que no venga en `courses`.

export interface CourseLike {
  id: number | string;
  active?: boolean | number | string | null;
}

// Solo es inactivo si el backend lo dice explícitamente; ante la duda, activo.
export function isCourseInactive(course?: CourseLike | null): boolean {
  if (!course) return false;
  const { active } = course;
  return active === false || active === 0 || active === '0';
}

export interface SplitCourses<T extends CourseLike> {
  active: T[];
  inactive: T[];
}

// Tolera courseteachers ausente: algunos endpoints no traen la relación.
export function splitCoursesByStatus<T extends CourseLike>(
  courses?: T[] | null,
): SplitCourses<T> {
  const active: T[] = [];
  const inactive: T[] = [];
  (courses || []).forEach((course) => {
    if (isCourseInactive(course)) inactive.push(course);
    else active.push(course);
  });
  return { active, inactive };
}

export function formatCourseNames(courses?: Array<{ name?: string | null }> | null): string {
  return (courses || [])
    .map((course) => course.name)
    .filter(Boolean)
    .join(', ');
}

export interface GradeSectionCourse extends CourseLike {
  grade_id?: number | string | null;
  section?: number | string | null;
}

// Un docente "está" en el curso del alumno solo si la asignación es a un curso activo:
// la app de docentes no muestra los inactivos. gradeId/section null = no filtra.
export function hasActiveCourseMatching(
  courses: GradeSectionCourse[] | null | undefined,
  gradeId?: number | string | null,
  section?: number | string | null,
): boolean {
  return splitCoursesByStatus(courses).active.some((course) => {
    const gradeMatch = gradeId == null || String(course.grade_id) === String(gradeId);
    const sectionMatch = section == null || String(course.section) === String(section);
    return gradeMatch && sectionMatch;
  });
}
